<div class="row">
  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>Dialog</h1>
    <h4>
      <a
        href="https://material.angular.io/components/dialog/examples"
        title="Material dialog"
        target="_blank"
        >Doc</a
      >
    </h4>

    <button
      mat-raised-button
      (click)="openDialog()">
      open
    </button>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>SnackBar</h1>
    <h4>
      <a
        href="https://material.angular.io/components/snack-bar/examples"
        title="Material SnackBar"
        target="_blank"
        >Doc</a
      >
    </h4>

    <button
      mat-raised-button
      (click)="openSnackBar()">
      open
    </button>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>Tooltip</h1>
    <h4>
      <a
        href="https://material.angular.io/components/tooltip/examples"
        title="Material Tooltip"
        target="_blank"
        >Doc</a
      >
    </h4>

    <button
      mat-raised-button
      matTooltip="I am doing nothing, but in tooltip !">
      What am i doing ?
    </button>
  </div>
</div>
